import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <path
      className="fill-change"
      fill="#9F9F9F"
      fillRule="nonzero"
      d="M24 9c4.585 0 8.3 4.365 8.3 9.75 0 2.321-.69 4.453-1.843 6.127 4.896 1.54 7.733 5.11 8.514 10.71a3.008 3.008 0 0 1-2.765 3.404l-.224.009H12.019a3.003 3.003 0 0 1-2.99-3.412c.781-5.6 3.619-9.17 8.513-10.711-1.152-1.674-1.843-3.806-1.843-6.127C15.7 13.365 19.416 9 24 9zm0 3c-2.795 0-5.282 2.921-5.282 6.75 0 1.661.476 3.214 1.315 4.433l1.144 1.663a1.5 1.5 0 0 1-.786 2.28l-1.938.61c-3.746 1.18-5.808 3.774-6.434 8.264l23.852.002.11-.002-.067-.443c-.698-4.218-2.746-6.68-6.368-7.82l-1.94-.61a1.5 1.5 0 0 1-.784-2.282l1.144-1.662c.84-1.22 1.316-2.772 1.316-4.433 0-3.829-2.487-6.75-5.282-6.75z"
    />
  </svg>
);
